module.exports = __webpack_public_path__ + "img/copy.90697d46.svg";